import { motion } from 'framer-motion';

export function Greeting() {
  return (
    <motion.section
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div>
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="rounded-3xl shadow-xl overflow-hidden relative bg-white"
        >
          {/* 背景画像 */}
          <div className="absolute inset-0 opacity-20">
            <img
              src="/images/122.webp"
              alt=""
              className="w-full h-full object-cover"
            />
          </div>

          <div className="relative px-8 py-12 text-center">
            <div className="text-greeting leading-relaxed space-y-4 text-lg font-fairy text-center">
              <h2 className="text-3xl text-greeting font-bold font-fairy text-center mb-6">みなさまへ</h2>
              <p className="[&_span]:inline-block">
                <span className="sr-only">私たちは2022年11月7日に結婚しました 現在は沖縄でのんびりとした毎日を過ごしています</span>
                <span aria-hidden="true">
                  <span>私たちは</span>
                  <span>2022年11月7日に</span>
                  <span>結婚しました</span><br />
                  <span>現在は沖縄で</span>
                  <span>のんびりとした</span>
                  <span>毎日を過ごしています</span>
                </span>
              </p>
              <p className="[&_span]:inline-block">
                <span className="sr-only">このたび 日頃お世話になっている皆様へ感謝の気持ちを込めて ささやかながら結婚式を開くことにしました</span>
                <span aria-hidden="true">
                  <span>このたび</span>
                  <span>日頃お世話になっている</span>
                  <span>皆様へ</span>
                  <span>感謝の気持ちを込めて</span>
                  <span>ささやかながら</span>
                  <span>結婚式を開くことにしました</span>
                </span>
              </p>

              <p className="[&_span]:inline-block">
                <span className="sr-only">ご多用のところ恐縮ですが ぜひご出席いただけましたら嬉しく思います お会いできるのを心より楽しみにしております</span>
                <span aria-hidden="true">
                  <span>ご多用のところ</span>
                  <span>恐縮ですが</span>
                  <span>ぜひご出席いただけましたら</span>
                  <span>嬉しく思います</span>
                  <span>お会いできるのを</span>
                  <span>心より楽しみにしております</span>
                </span>
              </p>

            </div>

            <div className="mt-8 space-y-2 text-greeting">
              <p className="text-xl font-fairy">新郎 憲人</p>
              <p className="text-xl font-fairy">新婦 実佳</p>
            </div>
          </div>
        </motion.div>
      </div>
    </motion.section>
  );
}
